/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PolicyCategory = {
    PrivacyPolicy: 'PrivacyPolicy',
    ParentalSignUpConsent: 'ParentalSignUpConsent',
    ParentalRegistrationConsent: 'ParentalRegistrationConsent',
    SurchargeDisclaimer: 'SurchargeDisclaimer'
} as const;
export type PolicyCategory = typeof PolicyCategory[keyof typeof PolicyCategory];


export function instanceOfPolicyCategory(value: any): boolean {
    for (const key in PolicyCategory) {
        if (Object.prototype.hasOwnProperty.call(PolicyCategory, key)) {
            if (PolicyCategory[key as keyof typeof PolicyCategory] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PolicyCategoryFromJSON(json: any): PolicyCategory {
    return PolicyCategoryFromJSONTyped(json, false);
}

export function PolicyCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PolicyCategory {
    return json as PolicyCategory;
}

export function PolicyCategoryToJSON(value?: PolicyCategory | null): any {
    return value as any;
}

export function PolicyCategoryToJSONTyped(value: any, ignoreDiscriminator: boolean): PolicyCategory {
    return value as PolicyCategory;
}

